import type {
    Locale as HostLocale,
    UnnormalizedLocale,
    NormalizedLocale,
} from '@jet-app/music-classical/dependencies/locale';
import { Locale as AppLocale } from '~/utils/locale';

export class Locale implements HostLocale {
    constructor(private defaultStorefront?: string | undefined) {}

    normalize(unnormalizedLocale: UnnormalizedLocale): NormalizedLocale {
        const { storefront, language } = unnormalizedLocale;

        // Jet expects null for language if the language is the storefront default.
        // This supports informing it whether the `?l` param should be
        // added to canonical URLs that we have to generate (ex.
        // /us/browse).
        return AppLocale.canonicalize({
            // This allows defaulting to the user storefront in SSR on all routes
            // See: rdar://142476474 ([Web] Users are always directed to US storefront)
            storefront: storefront ?? this.defaultStorefront,
            language,
        });
    }
}
